export default function AdvertisingAutomation() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-bold text-lg mb-4">
            ⑦ 広告運用の自動化（激アツ）
          </div>
          <p className="text-2xl font-bold text-gray-900 mt-4">
            ここ、99%がやってない。
          </p>
        </div>
        
        <div className="bg-white rounded-2xl p-8 shadow-lg mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">自動最適化</h3>
          
          <div className="mb-8">
            <h4 className="text-xl font-bold text-gray-900 mb-6">広告データ：</h4>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
              {[
                { label: 'CTR', icon: 'ri-cursor-line' },
                { label: 'CPC', icon: 'ri-money-dollar-circle-line' },
                { label: 'CVR', icon: 'ri-exchange-line' },
                { label: 'ACOS', icon: 'ri-percent-line' },
                { label: '売上', icon: 'ri-line-chart-line' },
                { label: '利益', icon: 'ri-funds-line' }
              ].map((item, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-4 text-center">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                    <i className={`${item.icon} text-xl text-primary`}></i>
                  </div>
                  <div className="font-bold text-gray-900">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-primary/5 to-primary/10 border-2 border-primary rounded-xl p-8">
            <h4 className="text-xl font-bold text-gray-900 mb-6">ロジック例</h4>
            <div className="space-y-4">
              <div className="bg-white rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-stop-circle-line text-xl text-red-600"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 mb-1">IF ACOS &gt; 40%</p>
                    <p className="text-primary font-bold">→ 停止</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-up-circle-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 mb-1">IF CVR &gt; 10%</p>
                    <p className="text-primary font-bold">→ 予算増加</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-pause-circle-line text-xl text-yellow-600"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900 mb-1">IF 3日売上0</p>
                    <p className="text-primary font-bold">→ キーワード停止</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-2xl p-8 shadow-lg">
          <div className="flex items-center gap-4">
            <i className="ri-robot-2-line text-5xl"></i>
            <div>
              <p className="text-3xl font-black mb-2">→ 広告運用が無人化。</p>
              <p className="text-lg opacity-90">24時間365日、最適な判断を自動実行</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
